export const gift = [
  {
    text: "mobiles & more",   
      alldata: [
        {
          heading: "smartphones & tablets",
          child: [
            "i kall",
            "mi",
            "realme",
            "samsung",
            "vivo",
            "oppo",
          ],
        },
       
        {
          heading: "feature phones",
          child: [
            "micromax",
            "nokia",
            "mtR",
            "heemax",
            "karbonn",
            "samsung",
            "blackbear",
          ],
        },
        {
          heading: "gaming consoles",
          child: [
            "gaming titles",
            "gaming accessories",
                  ],
        },
        {
          heading: "storage devices",
          child: [
            "memory cards",
            "pen drives",
            "external hard drives",
           
          ],
        },
        {
          heading: "branded accesories",
          child: [
            "toshiba",
            "sandisk",
               "boat",
            "jbl",
            "zebronics",
            "syska",
        
          ],
        },
        {
          heading: "laptops",
          child: [
            "hp",
            "lenovo",
            "asus",
            "acer",
            "coconics",
           
          ],
        },
      ],
    },
  
 
  
  {
    text: "women",
      alldata: [
        {
          heading: "ethnic wear",
          child: [
            "sareess",
            "kurtas & kurtis",
             "lehengas and gowns",
              "dress material",
           
            "shop all...",
          ],
        },
        {
          heading: "plus size clothing",
          child: [
            "bras, panties & lingerie",
            "dresses",
            "jeans",
            "pants",
            "tops",
            "shop all...",
          ],
        },
        {
          heading: "western wear",
          child: [
            "top & tees",
            "leggings",
            "jeans",
            "pantalons & shorts",
          
          ],
        },
        {
          heading: "Women`s tops",
          child: [
            "blouses",
            "button down tops",
            "hoodies & sweatshirts",
            "tunices",
            "chemises",
            "T-shirts",
            "shop all...",
          ],
        },
        {
          heading: "Women`s footwear",
          child: [
            "Heels",
            "wedges",
            "sneakers",
            "boots",
          
          ],
        },
      ],
    },

  {
    text: "appliances",
     
      alldata: [
        {
          heading: "tv & dth",
          child: [
            "television",
            "full hd",
            "hd ready",
            "ultra hd",
                     ],
        },
        {
          heading: "shop tv by screen",
          child: [
            "below 32 inch",
            "32 inch",
            "39 inch - 42 inch",
       
          ],
        },
        {
          heading: "large home appliances",
          child: [
            "air conditioners",
            "split acs",
            "window acs",
                       "show all...",
          ],
        },
        {
          heading: "refrigerators",
          child: [
            "single door",
            "double door",
            "side by side",
                     ],
        },
        {
          heading: "washing machines",
          child: [
            "semi automatic",
            "fully automatic",
            "shop all...",
          ],
        },
        {
          heading: "large kitchen appliances",
          child: [
            "chimneys & hoods",
            "otg",
            "dishwashers",
            "microwave",
              "shop all...",
          ],
        },
      ],
    },
 
  {
    text: "global shopping",
     
    },

  {
    text: "Offers",
    
  },
  {
    text: "men",
    
      alldata: [
        {
          heading: "clothing",
          child: [
            "accessories & combo sets",
            "cargos, shorts & 3/4ths",
              "inner Wear & sleep Wear",
            "jeans",
            "shirts",
                  "trousers",
            "Winter & seasonal Wear",
          ],
        },
        {
          heading: "big & tall clothing",
          child: [
            "active & Outdoor",
            "pants",
            "polos",
            "shirts",
            "suits & sport coats",
            "shop all...",
          ],
        },
              {
          heading: "footwear",
          child: [
            "casual shoes",
            "formal shoes",
            "sandals & floaters",
            "slippers & flip flops",
            "sports shoes",
          ],
        },
        {
          heading: "beauty and personal care",
          child: [
            "sivanna men's grooming",
            "gifts & gadgets",
            "hats",
            "ties & pocket squares",
            "Wallets & money clips",
            "shop all...",
          ],
        },
        {
          heading: "men's jewelry & Watches",
          child: [
            "bracelets",
            "jewelry sets",
            "necklaces",
            "Rings",
            "Watches",
            "shop all...",
          ],
        },
      ],
    },
];
